import { Markdown } from "@/components/CodeGen";
import { Card, CardContent } from "@/components/ui/card";
import { Bot, User } from "lucide-react";
import type { FpMessage } from "../../../../../schemas/codegen";

interface MessageBubbleProps {
  message: FpMessage;
  combinedContent: string;
}

export function MessageBubble({
  message,
  combinedContent,
}: MessageBubbleProps) {
  const isUser = message.sender === "user";
  const isAgent = message.sender === "agent";

  return (
    <div className="space-y-1">
      <div
        className={`flex items-start gap-3 ${
          isUser ? "justify-end" : "justify-start"
        }`}
      >
        {isAgent && (
          <div className="flex-shrink-0 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
            <Bot className="w-3 h-3 text-primary-foreground" />
          </div>
        )}

        <Card
          className={`max-w-[80%] ${
            isUser ? "bg-primary text-primary-foreground" : "bg-background"
          }`}
        >
          <CardContent className="p-3">
            {combinedContent?.trim() ? (
              <div className="text-sm mb-2">
                {isUser ? (
                  <p>{combinedContent}</p>
                ) : (
                  <Markdown className="prose prose-sm max-w-none" compact>
                    {combinedContent}
                  </Markdown>
                )}
              </div>
            ) : null}
            <p
              className={`text-xs ${
                isUser ? "text-primary-foreground/70" : "text-muted-foreground"
              }`}
            >
              {new Date(message.createdAt)?.toLocaleTimeString()}
            </p>
          </CardContent>
        </Card>

        {isUser && (
          <div className="flex-shrink-0 w-6 h-6 bg-muted rounded-full flex items-center justify-center">
            <User className="w-3 h-3 text-muted-foreground" />
          </div>
        )}
      </div>
    </div>
  );
}
